import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialogClose } from '@angular/material/dialog';
import { InlineSvgComponent } from '../inline-svg/inline-svg.component';
import { MatTooltip } from '@angular/material/tooltip';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from '@angular/material/expansion';
import { NgStyle } from '@angular/common';
import { ResizeObserverDirective } from '../../directives/resizeObserver.directive';

@Component({
  selector: 'frmg-confirmation-dialog',
  templateUrl: './layers-help-dialog.component.html',
  styleUrls: ['./layers-help-dialog.component.scss'],
  imports: [MatDialogClose, InlineSvgComponent, MatTooltip, MatExpansionPanel, MatAccordion, MatExpansionPanelHeader, MatExpansionPanelTitle, NgStyle, ResizeObserverDirective]
})
export class LayersHelpDialogComponent {
  @ViewChild('container', { static: false }) container!: ElementRef<HTMLElement>;

  public layersHelpInfo = [
    {
      title: 'Canopy Height',
      description: 'Estimates the height of both forest canopies and non-forest land cover types.'
    },
    {
      title: 'Distance To Hazard',
      description: 'Is the straight-line distance in meters to locations with medium or high fuel hazard.'
    },
    {
      title: 'Exposure',
      description: 'Measures how likely an asset at a specific location can be impacted by wildfire hazards such as flames, radiant heat, and embers. It is influenced by the fuel hazard near the location and considers the nearby slopes and their respective azimuths.'
    },
    {
      title: 'Fuel Hazard',
      description: 'Indicates the wildfire risk based on the types of fuels, such as different vegetation, present in an area. It affects how intense a fire might be and how quickly it could spread. Fuel hazard is rated as nil, low, medium, or high.'
    },
    {
      title: 'Fuel Type',
      description: 'Classify different land covers, like forests and grasslands, based on the types of wildfire fuels they contain. This classification depends on factors such as vegetation type, composition (e.g., percentage of conifer trees), and structure (e.g., forest height). SkyForest follows the classification system from the Wildland-Urban Interface guide.'
    },
    {
      title: 'Percent Conifer Basal Area',
      description: 'The PCBA shows the proportion of coniferous trees in a forest canopy. It is calculated based on the species and size of the trees, measured by the area of the trunk’s cross-section.'
    }
  ];
  public hasScroll = false;

  constructor(
    private dialogRef: MatDialogRef<LayersHelpDialogComponent>) {
  }

  public checkForScroll(): void {
    this.hasScroll = this.container.nativeElement.scrollHeight > this.container.nativeElement.clientHeight;
  }

  public closeDialog(result: any): void {
    this.dialogRef.close(result);
  }
}
